var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Tabs } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import { styles } from './custom-tabs-styles';
import ScrollButton from './scroll-button';
import ScrollButtonNew from './scroll-button-new';
var CustomTabs = function (_a) {
    var _b, _c, _d;
    var classes = _a.classes, newStyleArrows = _a.newStyleArrows, spreadOut = _a.spreadOut, props = __rest(_a, ["classes", "newStyleArrows", "spreadOut"]);
    var _classes = styles();
    // Any keys from the local styles need to be accounted for and merged with the passed classes
    var _e = classes || {}, _f = _e.indicator, indicator = _f === void 0 ? '' : _f, _g = _e.scrollButtons, scrollButtons = _g === void 0 ? '' : _g;
    return (React.createElement(Tabs, __assign({ textColor: 'primary', variant: 'scrollable', scrollButtons: 'on', ScrollButtonComponent: newStyleArrows ? ScrollButtonNew : ScrollButton, classes: __assign(__assign({}, classes), { indicator: clsx(_classes.indicator, (_b = {}, _b[indicator] = indicator, _b)), scrollButtons: clsx(_classes.scrollButtons, (_c = {}, _c[_classes.combine] = !spreadOut, _c), (_d = {}, _d[scrollButtons] = scrollButtons, _d)) }) }, props)));
};
export default CustomTabs;
